import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import UserBasicInformation from "./UserBasicInformation";
import ChangeUserUsername from "./ChangeUserUsername";
import ChangeUserPassword from "./ChangeUserPassword";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";

export default function UserInformation() {
    const {id: userId} = useParams()
    const {state: location} = useLocation()
    const [fullName, setFullName] = useState("");
    const [userName, setUserName] = useState("");

    useEffect(() => {
        if (location && location.fullName) {
            setFullName(location.fullName)
        }
    }, [location]);


    const navigate = useNavigate()
    const [value, setValue] = useState(UserInformationTabTypes.BasicInfo.id);

    function handleChangeTabMenu(event, newValue) {
        setValue(newValue)
    }


    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb className={css`flex-grow: 1;
                  gap: .5rem;`} breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Users.name,
                        RouteHelper.Users.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        fullName,
                        ""
                    )
                ]}/>

                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>
            <TabContext value={value}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                     className={css`
                       border-color: var(--header-border-bottom-color) !important;
                       margin-top: 24px;
                     `}>
                    <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                        <Tab
                            label={UserInformationTabTypes.BasicInfo.title}
                            value={UserInformationTabTypes.BasicInfo.id}
                        />
                        <Tab
                            label={UserInformationTabTypes.UserName.title}
                            value={UserInformationTabTypes.UserName.id}
                        />
                        <Tab
                            label={UserInformationTabTypes.Password.title}
                            value={UserInformationTabTypes.Password.id}
                        />
                    </TabList>
                </Box>
                <TabPanel value={UserInformationTabTypes.BasicInfo.id}>
                    <UserBasicInformation userName={userName} setUserName={setUserName} setFullName={setFullName}/>
                </TabPanel>
                <TabPanel value={UserInformationTabTypes.UserName.id}>
                    <ChangeUserUsername username={userName} setUsername={setUserName}/>
                </TabPanel>
                <TabPanel value={UserInformationTabTypes.Password.id}>
                    <ChangeUserPassword/>
                </TabPanel>
            </TabContext>

        </RaikoBaseContainer>
    )
}
export const GenderDeterminationSelection = {
    MALE: {
        name: "مرد",
        key: "MALE"
    },
    FEMALE: {
        name: "زن",
        key: "FEMALE"
    },
}
export const UserInformationTabTypes = {
    BasicInfo: {
        id: "basic-info",
        title: "اطلاعات پایه"
    },
    UserName: {
        id: "user-name",
        title: "نام کاربری"
    },
    Password: {
        id: "password",
        title: "رمز عبور"
    },
}